import { useEffect, useRef, useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "./font/Inter_24pt-Regular-normal";
import InterBold from "./font/Inter_24pt-Bold-normal";
import QRCode from "qrcode";
import uRLs from "../utils/baseUtils";
import { formatCurrency } from "@heartinz/finance";
import { FormatedSaleData } from "../utils/GloabalSaleData";
import InvoiceLayout from "./common/InvoiceLayout ";
import InvoiceWrapper from "./common/InvoiceWrapper";

const PrimeInvoice = ({ isData,  }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [download, setDownload] = useState(false);

  const [data, setData] = useState({});
  const selectedTheme = isData?.storeSettings?.invoiceSettings?.template;
  const terms = isData?.storeSettings?.invoiceSettings?.termsAndConditions;
  const globalData = FormatedSaleData(data);
  const actualPaidAmount = globalData?.grandtotal - globalData?.balanceDue;
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const generateInvoice1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING ; // Starting height
    const imagePath =
           uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;
    if (globalData?.salefrom?.image) {
        try {
  
            const logoBase64 = await urlToBase64(imagePath);
            const { width, height } = await loadImageDimensions(logoBase64);
            // 1. DRAW LOGO (Far Left)
            const maxWidth = 30;
            const maxHeight = 12;
             const ratio = Math.min(maxWidth / width, maxHeight / height);
            const finalW = width * ratio;
            const finalH = height * ratio;
             
            doc.addImage(logoBase64, "PNG", MARGIN_LEFT, y, finalW, finalH);
            doc.setFont("Inter-Regular", "normal");
            doc.setFontSize(9);
            doc.setTextColor(0);
            doc.text("TAX INVOICE", centerX, y + 3, { align: "center" });
    
            doc.setFont("Inter-Bold", "bold");
            doc.setFontSize(11); 
            doc.setTextColor(0);
            doc.text(globalData?.salefrom?.title?.toUpperCase() || "", centerX, y + 8, { align: "center" });
    
            doc.setFontSize(9);
            doc.setTextColor(0);
            
            // Invoice No Row     
            
          const invLabel = "Invoice No. ";
          const invVal = globalData?.saleno || "-";      
          const invDateTime = DateConverter.ISOToDisplayFormat(
                 DateConverter.convertToTimeZone(globalData?.saledate, timezone),
               ).time;
          const dateStr = `DATE: ${globalData?.saledate ? DateConverter.ISOToDisplayFormat(globalData?.saledate).date : "-"}  `;
          const timeStr = `TIME: ${invDateTime || ""}`;
          const invValW = doc.getTextWidth(invVal);
          doc.setFont("Inter-Regular", "normal");
          doc.text(invLabel, MARGIN_RIGHT - invValW - doc.getTextWidth(invLabel), y + 2);
          doc.setFont("Inter-Bold", "bold");
          doc.text(invVal, MARGIN_RIGHT, y + 2, { align: "right" });
          const totalDateTimeWidth = doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);
    
          const lineStartX = MARGIN_RIGHT - totalDateTimeWidth -1; // Adjust this number to make the line longer/shorter
          doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); // Light grey color
          doc.setLineWidth(0.1);
          doc.line(lineStartX, y + 4, MARGIN_RIGHT, y + 4);    
          
            const timeStrW = doc.getTextWidth(timeStr);
            doc.setFont("Inter-Regular", "normal");
            doc.text(dateStr, MARGIN_RIGHT - timeStrW - 1, y + 8, { align: "right" });
            doc.text(timeStr, MARGIN_RIGHT, y + 8, { align: "right" });  
                
            let addrY = y + finalH+4; // Move down below logo/title area
            doc.setFont("Inter-Regular", "normal");
            doc.setFontSize(9);
           //  doc.setTextColor(60, 60, 60);
     let currentTextY = addrY;
            const addrLine1 = [globalData?.salefrom?.addressline1, globalData?.salefrom?.addressline2].filter(Boolean).join(", ");
            const addrLine2 = [globalData?.salefrom?.district, globalData?.salefrom?.state, globalData?.salefrom?.pincode].filter(Boolean).join(", ");
           const maxWidthAdd = 60; // Adjust this value based on your layout
            const wrappedAddress1 = doc.splitTextToSize(addrLine1, maxWidthAdd);
            const wrappedAddress2 = doc.splitTextToSize(addrLine2, maxWidthAdd);
    
            if (addrLine1.trim()) {
            doc.text(wrappedAddress1, MARGIN_LEFT, currentTextY); 
             currentTextY += (wrappedAddress1.length * 4);
     }   if (addrLine2.trim()) {  
            doc.text(wrappedAddress2, MARGIN_LEFT, currentTextY);
            currentTextY += (wrappedAddress2.length * 4.5);
     }
            // const contactY = addrY + 6;
            let currentX = MARGIN_LEFT;
                 const phone = globalData?.salefrom?.phone;
    const gstin = globalData?.salefrom?.gstnumber;
    
            if (phone || gstin) {
            doc.setFont("Inter-Bold", "bold");
            doc.text("Ph:", currentX, currentTextY);
            currentX += doc.getTextWidth("Ph: ");
    
            doc.setFont("Inter-Regular", "normal");
            doc.text(`${globalData?.salefrom?.phone || ""}  `, currentX, currentTextY);
            currentX += doc.getTextWidth(`${phone || ""}  `);
            
            doc.setFont("Inter-Bold", "bold");
            doc.text("GSTIN:", currentX, currentTextY);
            currentX += doc.getTextWidth("GSTIN: ");
    
            doc.setFont("Inter-Regular", "normal");
            doc.text(`${gstin || ""}`, currentX, currentTextY);
            // doc.text(contactLine, MARGIN_LEFT, addrY + 6);
            }
            y = currentTextY + 2; 
    
        } catch (e) {
            console.warn("Header layout failed", e);
            y += 15;
        }
    }   
    
    y +=1;
    
    if(globalData?.saleto){
    let rowHeight = 6; // Adjusted to fit address + padding
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]);
    doc.setLineWidth(0.2);
    // doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    
    // 2. LEFT SIDE: "Customer Details :" and Customer Address
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("Customer Details :", MARGIN_LEFT + 2, y + 4);
    
    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleto?.name || "", MARGIN_LEFT + 2, y + 8);
    rowHeight+=4
    const fullAddress = [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state
    ].filter(Boolean).join(", ");
    const pinCode = globalData?.saleto?.pincode ? ` - ${globalData?.saleto.pincode}` : "";
    if(fullAddress ||pinCode){
      doc.setFontSize(9);
    const wrappedAddr = doc.splitTextToSize(fullAddress + pinCode, (pageW / 2) + 10);
    doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 12);
    rowHeight += wrappedAddr.length * 3.5;
    }
    const mrpStartX = MARGIN_LEFT + 136;
    doc.line(mrpStartX, y, mrpStartX, y + rowHeight);
    // Phone
    const rightSectionStart = mrpStartX + 2;
    doc.setFont("Inter-Bold", "bold");
    const phLabel = "Ph: ";
    const phVal = globalData?.saleto?.phone || "";
    doc.setFontSize(9);
    doc.text(phLabel, rightSectionStart, y + 4);
    doc.setFont("Inter-Regular", "normal");
    doc.text(phVal, rightSectionStart + doc.getTextWidth(phLabel), y + 4);
    
    // GSTIN
    doc.setFont("Inter-Bold", "bold");
    const gstLabel = "GSTIN: ";
    const gstVal = globalData?.saleto?.gstnumber || "";
    
    doc.text(gstLabel, rightSectionStart, y + 9);
    doc.setFont("Inter-Regular", "normal");
    doc.text(gstVal, rightSectionStart + doc.getTextWidth(gstLabel), y + 9);
    // Update Y for the next section (Table)
    doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    y += rowHeight ;
    }
        /* -------------------------------------------------
         PRODUCT TABLE1
      ------------------------------------------------- */
      const rowCount = globalData?.saleitems?.length;
    
     const standardHeight = 4;
    const targetTotalHeight = 40;
    const extraSpace = (rowCount > 0 && rowCount <= 5) 
        ? (targetTotalHeight - (rowCount * standardHeight)) 
        : 0;
    autoTable(doc, {
      startY: y,
      theme: "plain",
      rowPageBreak: 'avoid',
      margin: { 
        top: PADDING, 
        left: PADDING, 
        right: PADDING,  
        bottom: PADDING 
      },
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding:1.5,
        valign: "top",
        lineWidth: 0, // No default borders
        
      },
      headStyles: {
        font: "Inter-Bold",
       //  fontSize: 7,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
          textColor: selectedTheme?.templateTheme?.foregroundColor,
        lineWidth: 0.2,
        lineColor:(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]) 
      },
      bodyStyles: {
        minCellHeight: Math.max(2, standardHeight), 
      },
      head: [["#", "Item",  "Rate", "Qty","Taxable Val","Tax Amt" ,"Amount"]],
      body: globalData?.saleitems.map((it, i) => [
        i + 1,
        it.hsnsac ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}` : it.title,
        
        `₹${it.baseprice}`,
        it.quantity,`₹${it.lineTotalBasePrice}`,
        `₹${it.lineTotalTaxAmount}`,
        
        `₹${it.lineGrandTotal}`,
      ]),
       // body:repeatedBody,
     columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: "auto", halign: "left" },       
        2: { cellWidth: 20, halign: "right" },
        3: { cellWidth: 11, halign: "center" },
        4: { cellWidth: 22, halign: "right" },
        5: { cellWidth: 20, halign: "right" },
        6: { cellWidth: 22, halign: "right" },
      },
      didParseCell: function (data) {
        if (data.section === "head") {  
       
                const colId = data.column.index;
              if (colId === 0 || colId === 3) data.cell.styles.halign = "center";
              if (colId === 2 || colId === 4  || colId === 5 || colId === 6)
                data.cell.styles.halign = "right";
            }
        if (data.section === "body") {
          data.cell.styles.lineWidth = {
            left: 0.1, 
            right: 0.1, 
            top: 0,
            bottom: 0   
          };
          data.cell.styles.lineColor =(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]) ; // Black vertical lines
       if (data.row.index === rowCount - 1 ) {        
            data.cell.styles.minCellHeight = standardHeight + extraSpace;
          }
          if (data.row.index === rowCount - 1) {        
            data.cell.styles.lineWidth.bottom = 0.1;
          }
        }
      },
        didDrawPage: function (data) {
         const finalY = data.cursor.y;
         doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
         doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      }   
    });
 
     let finalY = doc.lastAutoTable.finalY;
 const footerHeight = 45; // Increased to accommodate the stacked boxes
 
 if (finalY + footerHeight > pageH - PADDING) {
   doc.addPage();
   finalY = PADDING;
 }
 
 const borderColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200];
 doc.setDrawColor(borderColor[0], borderColor[1], borderColor[2]);
 doc.setLineWidth(0.1);
 
 // X-coordinate for the vertical divider (aligns with the last column)
 const dividerX = MARGIN_RIGHT - 64; 
 const boxWidth = MARGIN_RIGHT - PADDING;
 const isInterState = globalData?.salefrom?.statecode && 
                      globalData?.saleto?.statecode && 
                      globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
     
 
 // --- BOX 1: TOTALS AND TAXES ---
 const box1Height = isInterState? 12:18;
 doc.rect(PADDING, finalY, boxWidth, box1Height); // Outer border
 doc.line(dividerX, finalY, dividerX, finalY + box1Height); // Vertical divider
 
 // Box 1 Content: In Words
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(9);
 doc.text("In Words:", PADDING + 2, finalY + 5);
 doc.setFont("Inter-Regular", "normal");
 const words = globalData?.amountinwords || "";
 doc.text(words, PADDING + 18, finalY + 5, { maxWidth: dividerX - PADDING - 17 });
 
   const taxSummary = [
     { label: "TOTAL", value: globalData?.grandtotal },
 
     ...(isInterState
       ? [{ label: "IGST", value: globalData?.igstamount || 0 }]
       : [
           { label: "CGST", value: globalData?.cgstamount || 0 },
           { label: "SGST", value: globalData?.sgstamount || 0 }
         ])
   ];
 
   taxSummary.forEach((item, i) => {
     let itemY = finalY + 4 + (i * 6);
     doc.text(item.label, dividerX + 2, itemY);
     doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
     if (i < taxSummary.length - 1) {
       doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2); // Mini horizontal lines
     }
   });
   const paymentData = [
     { label: "Cash", val: globalData?.cashPaid },
     { label: "Card", val: globalData?.cardPaid },
     { label: "UPI", val: globalData?.upiPaid },
     { label: "Online", val: globalData?.onlinePaid }
   ].filter(p => p.val > 0);
 
   // --- BOX 2: PAYMENTS AND PAYABLES ---
   const box2Y = finalY + box1Height;
   const box2Height = 12;
   doc.rect(PADDING, box2Y, boxWidth, box2Height); // Outer border
   doc.line(dividerX, box2Y, dividerX, box2Y + box2Height); // Vertical divider
 
   // Box 2 Content: Payment Methods (Left Side)
   let payX = PADDING + 2;
 
   paymentData.forEach((pay, index) => {
     const col = index % 2;              // 0 or 1 (2 per row)
     const row = Math.floor(index / 2); // row number
   const colWidth =50; // horizontal spacing
   const rowHeight = 5;
     const x = payX + (col * colWidth);
     const y = box2Y + 4 + (row * rowHeight);
     const displayVal = `₹${pay.val}`;
     doc.setFont("Inter-Bold", "bold");
     doc.text(displayVal, x, y);
     
 const valWidth = doc.getTextWidth(displayVal);
     doc.setFont("Inter-Regular", "normal");
     doc.text(` Paid via ${pay.label}`, x + valWidth + 1, y);
   });
  const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);
 
   // Box 2 Content: Payables (Right Side)
   const payableSummary = [
     { label: "Amount Payable", value: globalData?.balanceDue, isBold: true },
     { label: "Amount Paid", value: `${paidamount.toFixed(2)}`, isBold: false }
   ];
 
     payableSummary.forEach((item, i) => {
       let itemY = box2Y + 4 + (i * 6);
 const textColor=selectedTheme?.templateTheme?.foregroundColor;
       if (i === 0) {
           const themeColor = selectedTheme?.templateTheme?.primaryColor || "#F0F5FF";
           doc.setFillColor(themeColor);       
           doc.rect(dividerX + 0.5, itemY - 4, (MARGIN_RIGHT - dividerX) - 1, 6, 'F');
           // Draw the bottom separator line
           doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); 
           doc.line(dividerX, itemY - 4, MARGIN_RIGHT, itemY - 4);
           doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2);          
       }    
        if (item.isBold) {
       doc.setTextColor(textColor); 
       doc.setFont("Inter-Bold", "bold");
     } else {
       doc.setTextColor(0, 0, 0); // black
       doc.setFont("Inter-Regular", "normal");
     }
       doc.text(item.label, dividerX + 2, itemY);
       doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
   });
   const ensureSpace = (requiredHeight) => {
   if (signatureY + requiredHeight > pageH - PADDING) {
     doc.addPage();
     signatureY = PADDING;
   }
 };
 
 let signatureY = box2Y + 4 + (payableSummary.length * 6) ;
 const signatureBlockHeight = globalData?.storeSettings?.invoiceSettings?.signature ? 20 : 15;
 ensureSpace(signatureBlockHeight);
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(8);
 doc.text(`For ${globalData?.salefrom?.title}`, pageW - PADDING , signatureY+1 , { align: "right" });
 if (globalData?.storeSettings?.invoiceSettings?.signature) {
   try {
     const signimg = uRLs.IMAGE_URL + globalData?.storeSettings.invoiceSettings.signature;
     const base64 = await urlToBase64(signimg);
     const { width, height } = await loadImageDimensions(base64);
 
     const maxWidth = 25;
     const maxHeight = 10;
     const ratio = Math.min(maxWidth / width, maxHeight / height);
     const imgW = width * ratio;
     const imgH = height * ratio;
     signatureY+=4;
     doc.addImage(
       base64,
       signimg.endsWith(".png") ? "PNG" : "JPEG",
       MARGIN_RIGHT - imgW,
       signatureY,
       imgW,
       imgH
     );
 
   } catch {
     console.warn("Signature load failed");
   }
 } else {
   signatureY+=10;
   doc.setDrawColor(borderColor); 
   doc.line(pageW - PADDING - 30, signatureY , pageW - PADDING, signatureY );
 }
 
 // 👉 Label
 doc.setFont("Inter-Regular", "normal");
 doc.setFontSize(8);
 if (globalData?.storeSettings?.invoiceSettings?.signature) {
   signatureY+= 9;
 }else{
   signatureY+= 4;
 }
 doc.text("Authorized Signatory", MARGIN_RIGHT, signatureY , { align: "right" });
  // 👉 Row 2 (Terms)
 let termsStartY = signatureY + 8;
 
 
 // 👉 Estimate terms height
 const termLines = doc.splitTextToSize(terms || "", pageW - PADDING * 2);
 const termsHeight = 10 + (termLines.length * 4);
 
 // 👉 Page break BEFORE rendering
 if (termsStartY + termsHeight > pageH - PADDING) {
   doc.addPage();
   termsStartY = PADDING ;
 }
 
 if (terms?.length > 0) {
   doc.setFont("Inter-Bold", "bold");
   doc.setFontSize(9);
   doc.text("Terms & Conditions", PADDING, termsStartY);
 
   doc.setFont("Inter-Regular", "normal");
   doc.setFontSize(8);
 
   let currentY = termsStartY + 5;
   const termLines1 = doc.splitTextToSize(terms, pageW - PADDING * 2);
 
   termLines1.forEach((line) => {
     if (currentY > pageH - PADDING) {
       doc.addPage();
       currentY = PADDING;
     }
     doc.text(line, PADDING, currentY);
     currentY += 5;
   });
 
   termsStartY = currentY;
 }
 
    // 👉 Row 3 (Branding)
 if (globalData?.storeSettings?.negobillBranding) {
   let brandingY = termsStartY + 6;
 
   const normalText = "Powered by ";
   const boldText = "NegoBill.com";
 
   doc.setFontSize(10);
 
   doc.setFont("Inter-Regular", "normal");
   const normalW = doc.getTextWidth(normalText);
   doc.text(normalText, MARGIN_LEFT, brandingY);
 
   doc.setFont("Inter-Bold", "bold");
   doc.text(boldText, MARGIN_LEFT + normalW, brandingY);
 }
        return doc;
      };
 
   const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const centerX = pageW / 2;
    let y = PADDING ; // Starting height
    const imagePath =
           uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;
    if (globalData?.salefrom?.image) {
        try {
  
            const logoBase64 = await urlToBase64(imagePath);
            const { width, height } = await loadImageDimensions(logoBase64);
            // 1. DRAW LOGO (Far Left)
            const maxWidth = 30;
            const maxHeight = 12;
             const ratio = Math.min(maxWidth / width, maxHeight / height);
            const finalW = width * ratio;
            const finalH = height * ratio;
             
            doc.addImage(logoBase64, "PNG", MARGIN_LEFT, y, finalW, finalH);
            doc.setFont("Inter-Regular", "normal");
            doc.setFontSize(9);
            doc.setTextColor(0);
            doc.text("BILL RECEIPT", centerX, y + 3, { align: "center" });
    
            doc.setFont("Inter-Bold", "bold");
            doc.setFontSize(11); 
            doc.setTextColor(0);
            doc.text(globalData?.salefrom?.title?.toUpperCase() || "", centerX, y + 8, { align: "center" });
    
            doc.setFontSize(9);
            doc.setTextColor(0);
            
            // Invoice No Row     
            
          const invLabel = "Bill No. ";
          const invVal = globalData?.saleno || "-";      
          const invDateTime = DateConverter.ISOToDisplayFormat(
                 DateConverter.convertToTimeZone(globalData?.saledate, timezone),
               ).time;
          const dateStr = `DATE: ${globalData?.saledate ? DateConverter.ISOToDisplayFormat(globalData?.saledate).date : "-"}  `;
          const timeStr = `TIME: ${invDateTime || ""}`;
          const invValW = doc.getTextWidth(invVal);
          doc.setFont("Inter-Regular", "normal");
          doc.text(invLabel, MARGIN_RIGHT - invValW - doc.getTextWidth(invLabel), y + 2);
          doc.setFont("Inter-Bold", "bold");
          doc.text(invVal, MARGIN_RIGHT, y + 2, { align: "right" });
          const totalDateTimeWidth = doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);
    
          const lineStartX = MARGIN_RIGHT - totalDateTimeWidth -1; // Adjust this number to make the line longer/shorter
          doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); // Light grey color
          doc.setLineWidth(0.1);
          doc.line(lineStartX, y + 4, MARGIN_RIGHT, y + 4);    
          
            const timeStrW = doc.getTextWidth(timeStr);
            doc.setFont("Inter-Regular", "normal");
            doc.text(dateStr, MARGIN_RIGHT - timeStrW - 1, y + 8, { align: "right" });
            doc.text(timeStr, MARGIN_RIGHT, y + 8, { align: "right" });  
                
            let addrY = y + finalH+4; // Move down below logo/title area
            doc.setFont("Inter-Regular", "normal");
            doc.setFontSize(9);
           //  doc.setTextColor(60, 60, 60);
     let currentTextY = addrY;
            const addrLine1 = [globalData?.salefrom?.addressline1, globalData?.salefrom?.addressline2].filter(Boolean).join(", ");
            const addrLine2 = [globalData?.salefrom?.district, globalData?.salefrom?.state, globalData?.salefrom?.pincode].filter(Boolean).join(", ");
           const maxWidthAdd = 60; // Adjust this value based on your layout
            const wrappedAddress1 = doc.splitTextToSize(addrLine1, maxWidthAdd);
            const wrappedAddress2 = doc.splitTextToSize(addrLine2, maxWidthAdd);
    
            if (addrLine1.trim()) {
            doc.text(wrappedAddress1, MARGIN_LEFT, currentTextY); 
             currentTextY += (wrappedAddress1.length * 4);
     }   if (addrLine2.trim()) {  
            doc.text(wrappedAddress2, MARGIN_LEFT, currentTextY);
            currentTextY += (wrappedAddress2.length * 4.5);
     }
            // const contactY = addrY + 6;
            let currentX = MARGIN_LEFT;
                 const phone = globalData?.salefrom?.phone;
    const gstin = globalData?.salefrom?.gstnumber;
    
            if (phone || gstin) {
            doc.setFont("Inter-Bold", "bold");
            doc.text("Ph:", currentX, currentTextY);
            currentX += doc.getTextWidth("Ph: ");
    
            doc.setFont("Inter-Regular", "normal");
            doc.text(`${globalData?.salefrom?.phone || ""}  `, currentX, currentTextY);
            currentX += doc.getTextWidth(`${phone || ""}  `);
            
           
            }
            y = currentTextY + 2; 
    
        } catch (e) {
            console.warn("Header layout failed", e);
            y += 15;
        }
    }   
    
    y +=1;
    
    if(globalData?.saleto){
    let rowHeight = 6; // Adjusted to fit address + padding
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]);
    doc.setLineWidth(0.2);
    // doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    
    // 2. LEFT SIDE: "Customer Details :" and Customer Address
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("Customer Details :", MARGIN_LEFT + 2, y + 4);
    
    doc.setFontSize(9);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleto?.name || "", MARGIN_LEFT + 2, y + 8);
    rowHeight+=4
    const fullAddress = [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state
    ].filter(Boolean).join(", ");
    const pinCode = globalData?.saleto?.pincode ? ` - ${globalData?.saleto.pincode}` : "";
    if(fullAddress ||pinCode){
      doc.setFontSize(9);
    const wrappedAddr = doc.splitTextToSize(fullAddress + pinCode, (pageW / 2) + 10);
    doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 12);
    rowHeight += wrappedAddr.length * 3.5;
    }
    const mrpStartX = MARGIN_LEFT + 163;
    doc.line(mrpStartX, y, mrpStartX, y + rowHeight);
    // Phone
    const rightSectionStart = mrpStartX + 2;
    doc.setFont("Inter-Bold", "bold");
    const phLabel = "Ph: ";
    const phVal = globalData?.saleto?.phone || "";
    
    doc.text(phLabel, rightSectionStart, y + 4);
    doc.setFont("Inter-Regular", "normal");
    doc.text(phVal, rightSectionStart + doc.getTextWidth(phLabel), y + 4);
    
  
    // Update Y for the next section (Table)
    doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    y += rowHeight ;
    }
        /* -------------------------------------------------
         PRODUCT TABLE1
      ------------------------------------------------- */
      const rowCount = globalData?.saleitems?.length;
    
     const standardHeight = 4;
    const targetTotalHeight = 40;
    const extraSpace = (rowCount > 0 && rowCount <= 5) 
        ? (targetTotalHeight - (rowCount * standardHeight)) 
        : 0;
    autoTable(doc, {
      startY: y,
      theme: "plain",
      rowPageBreak: 'avoid',
      margin: { 
        top: PADDING, 
        left: PADDING, 
        right: PADDING,  
        bottom: PADDING 
      },
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding:1.5,
        valign: "top",
        lineWidth: 0, // No default borders
        
      },
      headStyles: {
        font: "Inter-Bold",
       //  fontSize: 7,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
          textColor: selectedTheme?.templateTheme?.foregroundColor,
        lineWidth: 0.2,
        lineColor:(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]) 
      },
      bodyStyles: {
        minCellHeight: Math.max(2, standardHeight), 
      },
      head: [["#", "Item",  "Rate", "Qty" ,"Amount"]],
      body: globalData?.saleitems.map((it, i) => [
        i + 1,
        it.hsnsac ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}` : it.title,
        
        `₹${it.baseprice}`,
        it.quantity,
        
        `₹${it.lineGrandTotal}`,
      ]),
       // body:repeatedBody,
     columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: "auto", halign: "left" },       
        2: { cellWidth: 22, halign: "right" },
        3: { cellWidth: 15, halign: "center" },
        4: { cellWidth: 22, halign: "right" },
      
      },
      didParseCell: function (data) {
        if (data.section === "head") {  
       
                const colId = data.column.index;
              if (colId === 0 || colId === 3) data.cell.styles.halign = "center";
              if (colId === 2 || colId === 4  || colId === 5 || colId === 6)
                data.cell.styles.halign = "right";
            }
        if (data.section === "body") {
          data.cell.styles.lineWidth = {
            left: 0.1, 
            right: 0.1, 
            top: 0,
            bottom: 0   
          };
          data.cell.styles.lineColor =(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]) ; // Black vertical lines
       if (data.row.index === rowCount - 1 ) {        
            data.cell.styles.minCellHeight = standardHeight + extraSpace;
          }
          if (data.row.index === rowCount - 1) {        
            data.cell.styles.lineWidth.bottom = 0.1;
          }
        }
      },
        didDrawPage: function (data) {
         const finalY = data.cursor.y;
         doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
         doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
      }   
    });
 
     let finalY = doc.lastAutoTable.finalY;
 const footerHeight = 25; // Increased to accommodate the stacked boxes
 
 if (finalY + footerHeight > pageH - PADDING) {
   doc.addPage();
   finalY = PADDING;
 }
 
 const borderColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200];
 doc.setDrawColor(borderColor[0], borderColor[1], borderColor[2]);
 doc.setLineWidth(0.1);
 
 // X-coordinate for the vertical divider (aligns with the last column)
 const dividerX = MARGIN_RIGHT - 59; 
 const boxWidth = MARGIN_RIGHT - PADDING;
 
 // --- BOX 1: TOTALS AND TAXES ---
 const box1Height = 6;
 doc.rect(PADDING, finalY, boxWidth, box1Height); // Outer border
 doc.line(dividerX, finalY, dividerX, finalY + box1Height); // Vertical divider
 
 // Box 1 Content: In Words
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(9);
 doc.text("In Words:", PADDING + 2, finalY + 4);
 doc.setFont("Inter-Regular", "normal");
 const words = globalData?.amountinwords || "";
 doc.text(words, PADDING + 18, finalY + 4, { maxWidth: dividerX - PADDING - 17 });
 
   const taxSummary = [
     { label: "TOTAL", value: globalData?.grandtotal },
    
   ];
 
   taxSummary.forEach((item, i) => {
     let itemY = finalY + 4 + (i * 6);
     doc.text(item.label, dividerX + 2, itemY);
     doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });   
   });
   const paymentData = [
     { label: "Cash", val: globalData?.cashPaid },
     { label: "Card", val: globalData?.cardPaid },
     { label: "UPI", val: globalData?.upiPaid },
     { label: "Online", val: globalData?.onlinePaid }
   ].filter(p => p.val > 0);
 
   // --- BOX 2: PAYMENTS AND PAYABLES ---
   const box2Y = finalY + box1Height;
   const box2Height = 12;
   doc.rect(PADDING, box2Y, boxWidth, box2Height); // Outer border
   doc.line(dividerX, box2Y, dividerX, box2Y + box2Height); // Vertical divider
 
   // Box 2 Content: Payment Methods (Left Side)
   let payX = PADDING + 2;
 
   paymentData.forEach((pay, index) => {
     const col = index % 2;              // 0 or 1 (2 per row)
     const row = Math.floor(index / 2); // row number
   const colWidth =50; // horizontal spacing
   const rowHeight = 5;
     const x = payX + (col * colWidth);
     const y = box2Y + 4 + (row * rowHeight);
     const displayVal = `₹${pay.val}`;
     doc.setFont("Inter-Bold", "bold");
     doc.text(displayVal, x, y);
     
 const valWidth = doc.getTextWidth(displayVal);
     doc.setFont("Inter-Regular", "normal");
     doc.text(` Paid via ${pay.label}`, x + valWidth + 1, y);
   });
    const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);
 
   // Box 2 Content: Payables (Right Side)
   const payableSummary = [
     { label: "Amount Payable", value: globalData?.balanceDue, isBold: true },
     { label: "Amount Paid", value: `${paidamount.toFixed(2)}`, isBold: false }
   ];
 
     payableSummary.forEach((item, i) => {
       let itemY = box2Y + 4 + (i * 6);
 const textColor=selectedTheme?.templateTheme?.foregroundColor;
       if (i === 0) {
           const themeColor = selectedTheme?.templateTheme?.primaryColor || "#F0F5FF";
          
        
           doc.setFillColor(themeColor); 
           doc.setTextColor(textColor)      
           doc.rect(dividerX + 0.5, itemY - 4, (MARGIN_RIGHT - dividerX) - 1, 6, 'F');
           // Draw the bottom separator line
          doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); 
           doc.line(dividerX, itemY - 4, MARGIN_RIGHT, itemY - 4);
           doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2);          
       }    
      if (item.isBold) {
       doc.setTextColor(textColor); 
       doc.setFont("Inter-Bold", "bold");
     } else {
       doc.setTextColor(0, 0, 0); // black
       doc.setFont("Inter-Regular", "normal");
     }
 
       doc.text(item.label, dividerX + 2, itemY);
       doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
   });
   const ensureSpace = (requiredHeight) => {
   if (signatureY + requiredHeight > pageH - PADDING) {
     doc.addPage();
     signatureY = PADDING+1;
   }
 };
 
 let signatureY = box2Y + 4 + (payableSummary.length * 6) ;
 const signatureBlockHeight = globalData?.storeSettings?.invoiceSettings?.signature ? 20 : 15;
 ensureSpace(signatureBlockHeight);
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(8);
 doc.text(`For ${globalData?.salefrom?.title}`, pageW - PADDING , signatureY+1 , { align: "right" });
 
 if (globalData?.storeSettings?.invoiceSettings?.signature) {
   try {
     const signimg = uRLs.IMAGE_URL + globalData?.storeSettings.invoiceSettings.signature;
     const base64 = await urlToBase64(signimg);
     const { width, height } = await loadImageDimensions(base64);
 
     const maxWidth = 25;
     const maxHeight = 10;
     const ratio = Math.min(maxWidth / width, maxHeight / height);
     const imgW = width * ratio;
     const imgH = height * ratio;
     signatureY+=4;
     doc.addImage(
       base64,
       signimg.endsWith(".png") ? "PNG" : "JPEG",
       MARGIN_RIGHT - imgW,
       signatureY,
       imgW,
       imgH
     );
 
   } catch {
     console.warn("Signature load failed");
   }
 } else {
   signatureY+=10;
     doc.setDrawColor(borderColor); 
   doc.line(pageW - PADDING - 30, signatureY , pageW - PADDING, signatureY );
 }
 
 // 👉 Label
 doc.setFont("Inter-Regular", "normal");
 doc.setFontSize(8);
 if (globalData?.storeSettings?.invoiceSettings?.signature) {
   signatureY+= 9;
 }else{
   signatureY+= 4;
 }
 
 doc.text("Authorized Signatory", MARGIN_RIGHT, signatureY , { align: "right" });
  // 👉 Row 2 (Terms)
 let termsStartY = signatureY + 8;
 
 const termLines = doc.splitTextToSize(terms || "", pageW - PADDING * 2);
 const termsHeight = 10 + (termLines.length * 4);
 
 // 👉 Page break BEFORE rendering
 if (termsStartY + termsHeight > pageH - PADDING) {
   doc.addPage();
   termsStartY = PADDING +1;
 }
 
 if (terms?.length > 0) {
   doc.setFont("Inter-Bold", "bold");
   doc.setFontSize(9);
   doc.text("Terms & Conditions", PADDING, termsStartY);
   doc.setFont("Inter-Regular", "normal");
   const termLines1 = doc.splitTextToSize(terms, pageW - PADDING * 2);
 
 
   let currentY = termsStartY + 5;
 
   termLines1.forEach((line) => {
     if (currentY > pageH - PADDING) {
       doc.addPage();
       currentY = PADDING;
     }
     
     doc.text(line, PADDING, currentY);
     currentY += 5;
   });
 
   termsStartY = currentY;
 }
 
    // 👉 Row 3 (Branding)
 if (globalData?.storeSettings?.negobillBranding) {
   let brandingY = termsStartY + 6;
 
   const normalText = "Powered by ";
   const boldText = "NegoBill.com";
 
   doc.setFontSize(10);
 
   doc.setFont("Inter-Regular", "normal");
   const normalW = doc.getTextWidth(normalText);
   doc.text(normalText, MARGIN_LEFT, brandingY);
 
   doc.setFont("Inter-Bold", "bold");
   doc.text(boldText, MARGIN_LEFT + normalW, brandingY);
 }
        return doc;
      };

  const handleDownload = async (data) => {
    try {
      setDownload(true);

      const { salemode, saleno } = data || {};
      let doc;

      if (salemode?.toUpperCase() === "BILL") {
        doc = await generateBill1();
      } else {
        doc = await generateInvoice1();
      }

      const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");

      //  Fast direct download (no preview)
      doc.save(`${filenamePrefix}_${saleno}.pdf`);
      // /setPdfUrl(pdfUrl);
      //  Close tab after small delay
      setTimeout(() => {
        window.close();
      }, 100);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setDownload(false);
    }
  };

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

 
  useEffect(() => {
    if (data?.saleno) {
      handleDownload(data);
    }
  }, [data?.saleno]);


  useEffect(() => {
    setData(isData);
  }, [isData]);
 
  useEffect(() => {
    const upi = globalData?.storeSettings?.paymentSettings?.upiId;

    const name = globalData?.storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    globalData?.storeSettings?.paymentSettings?.upiId,
    globalData?.storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);
  const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
  const isBillReceipt =
    globalData?.salemode?.toUpperCase() === "BILL" &&
    globalData?.storeSettings?.saleSettings?.saleModeSettings?.isTaxInfo;
  const documentTitle = isBillReceipt
    ? "BILL RECEIPT"
    : "TAX INVOICE";

 return (
  <>        
      <InvoiceLayout>
                      {globalData?.salemode === "INVOICE" || isBillReceipt ? (
                        <>
                         
                           <InvoiceWrapper>
                                  <div className="tm_invoice_in p-3">
                                  
                                      <div className="row">
                                        <div className="col-6 col-md-4">
                                    
                                        <div>
                                          {globalData?.salefrom?.image && (
                                            <img
                                              src={
                                                uRLs.IMAGE_URL +
                                                "profile/" +
                                                globalData?.salefrom?.image
                                              }
                                              className="img-rounded logo mb-0 obj-contain"
                                              height="30"
                                              width="100"
                                            />
                                          )}
                                        </div>

                                        <div className="font-12">
                                          {globalData?.salefrom?.addressline1}{" "}
                                          {globalData?.salefrom?.addressline2}
                                        </div>
                                        <div className="font-12">
                                          {globalData?.salefrom?.district}{" "}
                                          {globalData?.salefrom?.state || ""}{" "}
                                          {globalData?.salefrom?.pincode || ""}
                                        </div>
                                        <div className="font-12">
                                          <span className="fw-bold">Ph:</span>{" "}
                                          {globalData?.salefrom?.phone}{" "}
                                          <span className="fw-bold">
                                            GSTIN:
                                          </span>{" "}
                                          {globalData?.salefrom?.gstnumber}
                                        </div>
                                     
                                     </div>
                                      <div className="col-6 col-md-4">
                                      <div
                                        style={{ flex: "1" }}
                                        className="text-center"
                                      >
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            color: "#555",
                                          }}
                                        >
                                          {documentTitle}
                                        </div>
                                        <div
                                          className="font012 mt-0"
                                          style={{
                                            fontWeight: "800",
                                            textTransform: "uppercase",
                                            lineHeight: "1",
                                          }}
                                        >
                                          {globalData?.salefrom?.title ||
                                            "COMPANY NAME"}
                                        </div>
                                      </div>
                                      </div>
                                     <div className="col-12 col-md-4">
                                      <div
                                        style={{ flex: "1" }}
                                        className="text-end"
                                      >
                                        <div className="text-end d-inline-block">
                                          <div
                                            className=" font-12 mb-0"
                                            style={{
                                              borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            {isBillReceipt ? "Bill No." : "Invoice No."}
                                            <span className="fw-bold">
                                              {" "}
                                              {globalData?.saleno}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-end font-12">
                                            {/* <span>DATE: {saleTime?.date}</span> */}
                                            <span> DATE: {saleTime?.date}</span>
                                            <span className="ms-3">
                                              TIME:{saleTime?.time}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      </div>
                                    </div>
                                   
                                    {globalData?.saleto &&
                                       (
                                        <div
                                          className="d-flex row g-0 "
                                          style={{
                                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                          }}
                                        >
                                           <div className="col-12 col-md-4 invoice-sections">
                                          <div
                                            style={{
                                              flex: "1",
                                              padding: "5px",
                                               borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,                                       
                                           "--mobile-border-color": selectedTheme?.templateTheme?.borderColor,
                                            }}
                                          >
                                            <span className="fw-bold font-12">
                                              Customer Details :
                                            </span>
                                            <div className="font-12 ">
                                              {globalData?.saleto?.name}
                                            </div>
                                            <div className="font-12">
                                              {" "}
                                              {globalData?.saleto
                                                ?.addressline1 &&
                                                `${globalData?.saleto?.addressline1}, `}
                                              {globalData?.saleto
                                                ?.addressline2 &&
                                                `${globalData?.saleto?.addressline2}, `}
                                              {globalData?.saleto?.district &&
                                                `${globalData?.saleto?.district}, `}
                                              {globalData?.saleto?.pincode &&
                                                ` - ${globalData?.saleto?.pincode}`}
                                            </div>
                                          </div>
                                          </div>
                                           <div className="col-12 col-md-4 ">
                                          {globalData?.saleto?.shippingAddress
                                            ?.addressline1 &&
                                            globalData?.saleto?.shippingAddress
                                              ?.addressline1 && (
                                                 
                                              <div
                                              className="invoice-sections"
                                                style={{
                                                  flex: "1",
                                                  padding: "5px",
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,                                       
                                           "--mobile-border-color": selectedTheme?.templateTheme?.borderColor,
                                                }}
                                              >
                                                <span className="fw-bold font-12">
                                                  shipping Details:
                                                </span>
                                                <div className="font-12 ">
                                                  {
                                                    globalData?.saleto
                                                      ?.shippingAddress?.name
                                                  }
                                                </div>
                                                <div className="font-12">
                                                  {" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.addressline1 &&
                                                    `${globalData?.saleto?.shippingAddress?.addressline1}, `}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.addressline2 &&
                                                    `${globalData?.saleto?.shippingAddress?.addressline2}, `}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.district &&
                                                    `${globalData?.saleto?.shippingAddress?.district}, `}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.pincode &&
                                                    ` - ${globalData?.saleto?.shippingAddress?.pincode}`}
                                                </div>
                                              </div>
                                              
                                            )}
                                            </div>
                                            <div className="col-12 col-md-3 invoice-sections"
                                            style={{                                     
                                           "--mobile-border-color": selectedTheme?.templateTheme?.borderColor,}}>
                                          <div
                                             className=""
                                            style={{
                                           
                                              width: "200px",
                                              padding: "5px",
                                              WebkitFontSmoothing:
                                                "antialiased",
                                              textRendering:
                                                "optimizeLegibility",
                                            
                                            }}
                                          >
                                            <div className="font-12">
                                              <span className="fw-bold">
                                                Ph:
                                              </span>{" "}
                                              {globalData?.saleto?.phone || ""}
                                            </div>
                                            <div className=" font-12">
                                              {" "}
                                              <span className="fw-bold">
                                                GSTIN:
                                              </span>{" "}
                                              {globalData?.saleto?.gstnumber ||
                                                ""}
                                            </div>
                                          </div>
                                          </div>
                                        </div>
                                      )}


                                       <div
                                      style={{
                                        width: "100%",
                                        overflowX: "auto",
                                        WebkitOverflowScrolling: "touch",
                                      }}
                                    >
                                    <table
                                      width="100%"
                                      className="mt-0"
                                      style={{ borderCollapse: "collapse" }}
                                    >
                                      <thead>
                                        <tr className=" fw-bold">
                                          <th
                                            className="force-style font-12 p-0 text-center"
                                            style={{
                                              width: "40px",

                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                                          >
                                            {" "}
                                            #
                                          </th>
                                          <th
                                            className="force-style font-12 p-0 ps-1"
                                            style={{
                                              textAlign: "left",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                                          >
                                            Item
                                          </th>

                                          <th
                                            className="force-style font-12 p-0 pe-1"
                                            style={{
                                              width: "80px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                                          >
                                            Rate
                                          </th>
                                          <th
                                            className="force-style font-12 p-0 pe-1 "
                                            style={{
                                              width: "60px",
                                              textAlign: "center",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                                          >
                                            Qty
                                          </th>
                                          <th
                                            // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                                            className="force-style font-12 p-0 pe-1"
                                            style={{
                                              width: "90px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Taxable Val
                                          </th>
                                          <th
                                            // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                                            className="force-style font-12 p-0 pe-1"
                                            style={{
                                              width: "90px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            {" "}
                                            Tax Amt
                                          </th>

                                          <th
                                            // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                                            className="force-style font-12 p-0 pe-1"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      {globalData?.saleitems?.length > 0 && (
                                        <tbody>
                                          {globalData?.saleitems?.map(
                                            (item, index) => (
                                              <tr
                                                key={index}
                                                className="font-12 align-top"
                                                style={{ height: "30px" }}
                                              >
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                                                    textAlign: "center",
                                                    borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  }}
                                                >
                                                  {index + 1}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    padding: "0 5px",
                                                  }}
                                                >
                                                  {item?.title}
                                                  {item.hsnsac && (
                                                    <div className="font-12">
                                                      <span className="fw-medium">
                                                        {" "}
                                                        {item.imode ===
                                                        "SERVICE"
                                                          ? "SAC:"
                                                          : "HSN:"}
                                                      </span>{" "}
                                                      {item.hsnsac}
                                                    </div>
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "right",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  ₹{item?.baseprice}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {item?.quantity}
                                                  <span className="font-11 ms-1">
                                                    {(() => {
                                                      const unitCode =
                                                        item?.isSecondaryUnit
                                                          ? item?.unitConfig
                                                              ?.secondaryUnitCode
                                                          : item?.unitConfig
                                                              ?.primaryUnitCode;

                                                      // return unitCode !== "unit" ? unitCode : "";
                                                      return unitCode || "";
                                                    })()}
                                                  </span>
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "right",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  ₹{item?.lineTotalBasePrice}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "right",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  ₹{item?.lineTotalTaxAmount}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "right",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  ₹{item?.lineGrandTotal}
                                                </td>
                                              </tr>
                                            ),
                                          )}

                                          {[
                                            ...Array(
                                              Math.max(
                                                0,
                                                5 -
                                                  (globalData?.saleitems
                                                    ?.length || 0),
                                              ),
                                            ),
                                          ].map((_, i) => (
                                            <tr
                                              key={`empty-${i}`}
                                              style={{ height: "50px" }}
                                            >
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      )}
                                      <tfoot
                                        style={{
                                          borderTop: `2px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        }}
                                      >
                                        <tr className="font-11">
                                          <td
                                            colSpan="5"
                                            style={{
                                              padding: "5px",
                                              verticalAlign: "top",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <span className="fw-bold">
                                              In Words:
                                            </span>{" "}
                                            {globalData?.amountinwords}
                                          </td>

                                          <td
                                            colSpan="3"
                                            style={{
                                              padding: "0",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <div
                                              className="d-flex justify-content-between p-0 px-2  font-12"
                                              style={{
                                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                              }}
                                            >
                                              <span>Total</span>
                                              <span className="">
                                                ₹{globalData?.grandtotal}
                                              </span>
                                            </div>
                                            {!isInterState ? (
                                              <>
                                                <div
                                                  className="d-flex justify-content-between p-0 px-2  font-12"
                                                  style={{
                                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  }}
                                                >
                                                  <span>CGST</span>
                                                  <span className="">
                                                    ₹
                                                    {globalData?.cgstamount ||
                                                      0}
                                                  </span>
                                                </div>
                                                <div className="d-flex justify-content-between p-0 px-2 font-12">
                                                  <span>SGST</span>
                                                  <span className="">
                                                    ₹
                                                    {globalData?.sgstamount ||
                                                      0}
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="d-flex justify-content-between p-0 px-2 font-12 ">
                                                <span>IGST</span>
                                                <span className="">
                                                  ₹{globalData?.igstamount || 0}
                                                </span>
                                              </div>
                                            )}
                                          </td>
                                        </tr>

                                        {/* ROW 2: PAYMENT STATUS & SIGNATURE */}
                                        <tr className="font-12">
                                          {/* Left Side: Payment Methods (Cash/UPI/Card) */}
                                          <td
                                            colSpan="5"
                                            style={{
                                              padding: "0px",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <div className="row g-2 m-0">
                                              {globalData?.cashPaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>
                                                      ₹{globalData.cashPaid}
                                                    </b>{" "}
                                                    Paid via Cash
                                                  </span>
                                                </div>
                                              )}
                                              {globalData?.upiPaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>₹{globalData.upiPaid}</b>{" "}
                                                    Paid via UPI
                                                  </span>
                                                </div>
                                              )}
                                              {globalData?.cardPaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>
                                                      ₹{globalData.cardPaid}
                                                    </b>{" "}
                                                    Paid via Card
                                                  </span>
                                                </div>
                                              )}
                                              {globalData?.onlinePaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>
                                                      ₹{globalData.onlinePaid}
                                                    </b>{" "}
                                                    Paid via Online
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </td>

                                          {/* Right Side Stack: Payment Summary */}
                                          <td
                                            colSpan="3"
                                            style={{
                                              padding: "0",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <div
                                              className="d-flex justify-content-between p-0 px-2 border-bottom "
                                              style={{
                                                backgroundColor:
                                                  selectedTheme?.templateTheme
                                                    ?.primaryColor,
                                              }}
                                            >
                                              <span
                                                className="fw-bold font-12 "
                                                style={{
                                                  color:
                                                    selectedTheme?.templateTheme
                                                      ?.foregroundColor,
                                                }}
                                              >
                                                Amount Payable
                                              </span>
                                              <span
                                                className="fw-bold font-12 "
                                                style={{
                                                  color:
                                                    selectedTheme?.templateTheme
                                                      ?.foregroundColor,
                                                }}
                                              >
                                                ₹{globalData?.balanceDue || 0}
                                              </span>
                                            </div>
                                            <div className="d-flex justify-content-between p-0 px-2">
                                              <span className="font-12">
                                                Amount Paid
                                              </span>
                                              <span className="font-12 ">
                                                ₹
                                                {parseFloat(
                                                  actualPaidAmount || 0,
                                                ).toFixed(2)}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                    </div>

                                    <div className="row mt-2">
                                      <div className="col-12  ms-auto">
                                        <div className="text-end p-0 fw-bold font-12 mt-2 ">
                                          {globalData?.salefrom?.title}
                                        </div>
                                        <div>
                                          {globalData?.storeSettings?.invoiceSettings
                                            ?.signature ? (
                                            <div className="text-end p-0 fw-bold pb-1">
                                              <img
                                                src={
                                                  uRLs.IMAGE_URL +
                                                  globalData?.storeSettings?.invoiceSettings
                                                    ?.signature
                                                }
                                                width={100}
                                              />
                                            </div>
                                          ) : (
                                            <div className="p-0 pt-4">
                                              <hr
                                                className="m-1 ms-auto "
                                                style={{
                                                  border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  maxWidth: "120px",
                                                }}
                                              />
                                            </div>
                                          )}
                                          <div className="text-end p-0 font-12">
                                            Authorized Signatory
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-12 ">
                                        {terms?.length > 0 && (
                                          <table width="100%">
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    padding: "0px",
                                                  }}
                                                  width="100%"
                                                >
                                                  <div
                                                    className="font-12 fw-600"
                                                    style={{
                                                      textAlign: "left",
                                                      color: "black",
                                                    }}
                                                  >
                                                    Terms & Conditions
                                                  </div>
                                                  <div className="terms-box font-12">
                                                    {terms}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        )}
                                      </div>
                                    </div>
                                    {globalData?.storeSettings?.negobillBranding && (
                                      <>
                                        <div className="mt-2 font-11 d-flex justify-content-left ">
                                          <span>
                                            Powered By{" "}
                                            <span className="fw-bold">
                                              NegoBill.com
                                            </span>
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                              </InvoiceWrapper>
                          
                        </>
                      ) : globalData.salemode === "BILL" ? (
                        <>                          
                            <InvoiceWrapper>
                                  <div className="tm_invoice_in p-3">
                                    
                                     <div className="row">
                                        <div className="col-6 col-md-4">
                                    
                                        <div>
                                          {globalData?.salefrom?.image && (
                                            <img
                                              src={
                                                uRLs.IMAGE_URL +
                                                "profile/" +
                                                globalData?.salefrom?.image
                                              }
                                              className="img-rounded logo mb-0 obj-contain"
                                              height="30"
                                              width="100"
                                            />
                                          )}
                                        </div>

                                        <div className="font-12">
                                          {globalData?.salefrom?.addressline1}{" "}
                                          {globalData?.salefrom?.addressline2}
                                        </div>
                                        <div className="font-12">
                                          {globalData?.salefrom?.district}{" "}
                                          {globalData?.salefrom?.state || ""}{" "}
                                          {globalData?.salefrom?.pincode || ""}
                                        </div>
                                        <div className="font-12">
                                          <span className="fw-bold">Ph:</span>{" "}
                                          {globalData?.salefrom?.phone}{" "}
                                        </div>
                                      </div>
                                            
                                 <div className="col-6 col-md-4">
                                      <div
                                        style={{
                                          flex: "1",
                                          textAlign: "center",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            color: "#555",
                                          }}
                                        >
                                          BILL RECEIPT
                                        </div>
                                        <div
                                          className="font012 mt-0"
                                          style={{
                                            fontWeight: "800",
                                            textTransform: "uppercase",
                                            lineHeight: "1",
                                          }}
                                        >
                                          {globalData?.salefrom?.title ||
                                            "COMPANY NAME"}
                                        </div>
                                      </div>
                                  </div>
                                  <div className="col-12 col-md-4">
                                      <div
                                        style={{
                                          flex: "1",
                                          textAlign: "right",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "inline-block",
                                            textAlign: "right",
                                          }}
                                        >
                                          <div
                                            className=" font-12 mb-0"
                                            style={{
                                              borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            Bill No.
                                            <span className="fw-bold">
                                              {" "}
                                              {globalData?.saleno}
                                            </span>
                                          </div>
                                          <div className="d-flex justify-content-end font-12">
                                            {/* <span>DATE: {saleTime?.date}</span> */}
                                            <span> DATE: {saleTime?.date}</span>
                                            <span className="ms-3">
                                              TIME:{saleTime?.time}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      </div>
                                      </div>
                                    
                                    {globalData?.saleto && (
                                        <div
                                          className="d-flex  row g-0"
                                          style={{
                                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                          }}
                                        >
                                          <div className="col-12 col-md-4 invoice-sections">
                                          <div
                                            style={{
                                              flex: "1",
                                              padding: "5px",
                                              borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                             "--mobile-border-color": selectedTheme?.templateTheme?.borderColor,
                                            }}
                                          >
                                            <span className="fw-bold font-12">
                                              Customer Details :
                                            </span>
                                            <div className="font-12 ">
                                              {globalData?.saleto?.name}
                                            </div>
                                            <div className="font-12">
                                              {" "}
                                              {globalData?.saleto
                                                ?.addressline1 &&
                                                `${globalData?.saleto?.addressline1}, `}
                                              {globalData?.saleto
                                                ?.addressline2 &&
                                                `${globalData?.saleto?.addressline2}, `}
                                              {globalData?.saleto?.district &&
                                                `${globalData?.saleto?.district}, `}
                                              {globalData?.saleto?.pincode &&
                                                ` - ${globalData?.saleto?.pincode}`}
                                            </div>
                                          </div>
                                          </div>
                                            <div className="col-12 col-md-4 ">
                                          {(globalData?.saleto?.shippingAddress
                                            ?.addressline1 ||
                                            globalData?.saleto?.shippingAddress
                                              ?.addressline1) && (
                                            <div
                                             className="invoice-sections"
                                              style={{
                                                flex: "1",
                                                padding: "5px",
                                                borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                             "--mobile-border-color": selectedTheme?.templateTheme?.borderColor,
                                              }}
                                            >
                                              <span className="fw-bold font-12">
                                                shipping Details:
                                              </span>
                                              <div className="font-12">
                                                {" "}
                                                {globalData?.saleto
                                                  ?.shippingAddress
                                                  ?.addressline1 &&
                                                  `${globalData?.saleto?.shippingAddress?.addressline1}, `}
                                                {globalData?.saleto
                                                  ?.shippingAddress
                                                  ?.addressline2 &&
                                                  `${globalData?.saleto?.shippingAddress?.addressline2}, `}
                                                {globalData?.saleto
                                                  ?.shippingAddress?.district &&
                                                  `${globalData?.saleto?.shippingAddress?.district}, `}
                                                {globalData?.saleto
                                                  ?.shippingAddress?.pincode &&
                                                  ` - ${globalData?.saleto?.shippingAddress?.pincode}`}
                                              </div>
                                            </div>
                                          )}
                                          </div>
                                          <div className="col-12 col-md-3 invoice-sections"
                                            style={{                                     
                                           "--mobile-border-color": selectedTheme?.templateTheme?.borderColor,}}>
                                          <div
                                            style={{
                                              width: "159px",
                                              padding: "5px",
                                              WebkitFontSmoothing:
                                                "antialiased",
                                              textRendering:
                                                "optimizeLegibility",
                                            }}
                                          >
                                            <div className="font-12">
                                              <span className="fw-bold">
                                                Ph:
                                              </span>{" "}
                                              {globalData?.saleto?.phone || ""}
                                            </div>
                                          </div>
                                          </div>
                                        </div>
                                      )}
                                       <div
                                      style={{
                                        width: "100%",
                                        overflowX: "auto",
                                        WebkitOverflowScrolling: "touch",
                                      }}
                                    >
                                    <table
                                      width="100%"
                                      className="mt-0"
                                      style={{ borderCollapse: "collapse" }}
                                    >
                                      <thead>
                                        <tr className=" fw-bold">
                                          <th
                                            className="force-style font-12 p-0 text-center"
                                            style={{
                                              width: "40px",

                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                                          >
                                            {" "}
                                            #
                                          </th>
                                          <th
                                            className="force-style font-12 p-0 ps-1"
                                            style={{
                                              textAlign: "left",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                                          >
                                            Item
                                          </th>

                                          <th
                                            className="force-style font-12 p-0 pe-1"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                                          >
                                            Rate
                                          </th>
                                          <th
                                            className="force-style font-12 p-0 pe-1 "
                                            style={{
                                              width: "60px",
                                              textAlign: "center",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                            //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                                          >
                                            Qty
                                          </th>
                                          <th
                                            // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                                            className="force-style font-12 p-0 pe-1"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      {globalData?.saleitems?.length > 0 && (
                                        <tbody>
                                          {globalData?.saleitems?.map(
                                            (item, index) => (
                                              <tr
                                                key={index}
                                                className="font-12 align-top"
                                                style={{ height: "30px" }}
                                              >
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,

                                                    textAlign: "center",
                                                    borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  }}
                                                >
                                                  {index + 1}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    padding: "0 5px",
                                                  }}
                                                >
                                                  {item?.title}
                                                  {item.hsnsac && (
                                                    <div className="font-12">
                                                      <span className="fw-medium">
                                                        {" "}
                                                        {item.imode ===
                                                        "SERVICE"
                                                          ? "SAC:"
                                                          : "HSN:"}
                                                      </span>{" "}
                                                      {item.hsnsac}
                                                    </div>
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "right",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  ₹{item?.baseprice}
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {item?.quantity}
                                                  <span className="font-11 ms-1">
                                                    {(() => {
                                                      const unitCode =
                                                        item?.isSecondaryUnit
                                                          ? item?.unitConfig
                                                              ?.secondaryUnitCode
                                                          : item?.unitConfig
                                                              ?.primaryUnitCode;

                                                      // return unitCode !== "unit" ? unitCode : "";
                                                      return unitCode || "";
                                                    })()}
                                                  </span>
                                                </td>
                                                <td
                                                  style={{
                                                    borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                    textAlign: "right",
                                                    paddingRight: "5px",
                                                  }}
                                                >
                                                  ₹{item?.lineGrandTotal}
                                                </td>
                                              </tr>
                                            ),
                                          )}

                                          {[
                                            ...Array(
                                              Math.max(
                                                0,
                                                5 -
                                                  (globalData?.saleitems
                                                    ?.length || 0),
                                              ),
                                            ),
                                          ].map((_, i) => (
                                            <tr
                                              key={`empty-${i}`}
                                              style={{ height: "50px" }}
                                            >
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                              <td
                                                style={{
                                                  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              ></td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      )}
                                      <tfoot
                                        style={{
                                          borderTop: `2px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                        }}
                                      >
                                        <tr className="font-11">
                                          <td
                                            colSpan="3"
                                            style={{
                                              padding: "1px",
                                              verticalAlign: "top",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <span className="fw-bold ps-1 font-12">
                                              In Words:
                                            </span>{" "}
                                            {globalData?.amountinwords}
                                          </td>

                                          <td
                                            colSpan="3"
                                            style={{
                                              padding: "0",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <div className="d-flex justify-content-between p-0 px-2  font-12">
                                              <span>Total</span>
                                              <span className="">
                                                ₹{globalData?.grandtotal}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>

                                        {/* ROW 2: PAYMENT STATUS & SIGNATURE */}
                                        <tr className="font-12">
                                          {/* Left Side: Payment Methods (Cash/UPI/Card) */}
                                          <td
                                            colSpan="3"
                                            style={{
                                              padding: "0px",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <div className="row g-2 m-0">
                                              {globalData?.cashPaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>
                                                      ₹{globalData.cashPaid}
                                                    </b>{" "}
                                                    Paid via Cash
                                                  </span>
                                                </div>
                                              )}
                                              {globalData?.upiPaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>₹{globalData.upiPaid}</b>{" "}
                                                    Paid via UPI
                                                  </span>
                                                </div>
                                              )}
                                              {globalData?.cardPaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>
                                                      ₹{globalData.cardPaid}
                                                    </b>{" "}
                                                    Paid via Card
                                                  </span>
                                                </div>
                                              )}
                                              {globalData?.onlinePaid > 0 && (
                                                <div className="col-6 font-12 ps-1">
                                                  <span>
                                                    <b>
                                                      ₹{globalData.onlinePaid}
                                                    </b>{" "}
                                                    Paid via Online
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </td>

                                          {/* Right Side Stack: Payment Summary */}
                                          <td
                                            colSpan="3"
                                            style={{
                                              padding: "0",
                                              border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            <div
                                              className="d-flex justify-content-between p-0 px-2  "
                                              style={{
                                                backgroundColor: `${
                                                  selectedTheme?.templateTheme
                                                    ?.primaryColor
                                                }`,
                                              }}
                                            >
                                              <span
                                                className="fw-bold font-12 "
                                                style={{
                                                  color:
                                                    selectedTheme?.templateTheme
                                                      ?.foregroundColor,
                                                }}
                                              >
                                                Amount Payable
                                              </span>
                                              <span
                                                className="fw-bold font-12 "
                                                style={{
                                                  color:
                                                    selectedTheme?.templateTheme
                                                      ?.foregroundColor,
                                                }}
                                              >
                                                ₹{globalData?.balanceDue || 0}
                                              </span>
                                            </div>
                                            <div className="d-flex justify-content-between p-0 px-2">
                                              <span className="font-12">
                                                Amount Paid
                                              </span>
                                              <span className="font-12 ">
                                                ₹
                                                {parseFloat(
                                                  actualPaidAmount || 0,
                                                ).toFixed(2)}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-12  ms-auto">
                                        <div className="text-end p-0 fw-bold font-12 mt-2 ">
                                          {globalData?.salefrom?.title}
                                        </div>
                                        <div>
                                          {globalData?.storeSettings?.invoiceSettings
                                            ?.signature ? (
                                            <div className="text-end p-0 fw-bold pb-1">
                                              <img
                                                src={
                                                  uRLs.IMAGE_URL +
                                                  globalData?.storeSettings?.invoiceSettings
                                                    ?.signature
                                                }
                                                width={100}
                                              />
                                            </div>
                                          ) : (
                                            <div className="p-0 pt-4">
                                              <hr
                                                className="m-1 ms-auto "
                                                style={{
                                                  border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  maxWidth: "120px",
                                                }}
                                              />
                                            </div>
                                          )}
                                          <div className="text-end p-0 font-12">
                                            Authorized Signatory
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-12 ">
                                        {terms?.length > 0 && (
                                          <table width="100%">
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    padding: "0px",
                                                  }}
                                                  width="100%"
                                                >
                                                  <div
                                                    className="font-12 fw-600"
                                                    style={{
                                                      textAlign: "left",
                                                      color: "black",
                                                    }}
                                                  >
                                                    Terms & Conditions
                                                  </div>
                                                  <div className="terms-box font-12">
                                                    {terms}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        )}
                                      </div>
                                    </div>
                                    {globalData?.storeSettings?.negobillBranding && (
                                      <>
                                        <div className="mt-2 font-11 d-flex justify-content-left ">
                                          <span>
                                            Powered By{" "}
                                            <span className="fw-bold">
                                              NegoBill.com
                                            </span>
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                              </InvoiceWrapper>                         
                        </>
                      ) : (
                        <div className="default-content">
                          <p>No content available for this sale mode.</p>
                        </div>
                      )}
                      </InvoiceLayout>   
          </>
);
};

export default PrimeInvoice;
